import type { SectionItem } from '@/types/components/section-item'

export const ABOUT_SECTION_ITEMS_1: SectionItem[] = [
	{
		id: 'about-1',
		orangeTitleFirst: true,
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/images/gamer-lady.webp',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [
			{
				rotation: -15,
				length: 150,
				direction: 'counter-clockwise'
			}
		],
		circles: [
			{
				cx: 30,
				cy: 100,
				r: 100,
				fill: '#01629E'
			},
			{
				cx: 377.5,
				cy: 88,
				r: 21,
				fill: '#FF8A02'
			}
		]
	}
]

export const ABOUT_SECTION_ITEMS_2: SectionItem[] = [
	{
		id: 'about-1',
		orangeTitleFirst: true,
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/images/city-street.webp',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [
			{
				rotation: -15,
				length: 150,
				direction: 'counter-clockwise'
			}
		]
	}
]
